import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import "./Header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const logoSrc = `${process.env.PUBLIC_URL || ""}/images/grayman.jpeg`;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div className="header-logo" onClick={() => scrollToSection("hero")}>
          <img 
            src={logoSrc}
            alt="GrayMan Tech" 
            className="logo-image"
          />
        </div>

        <nav className={`header-nav ${isMobileMenuOpen ? "mobile-open" : ""}`}>
          <button
            onClick={() => scrollToSection("solutions")}
            className="nav-link"
          >
            Solutions
          </button>
          <button onClick={() => scrollToSection("services")} className="nav-link">
            Services
          </button>
          <button onClick={() => scrollToSection("process")} className="nav-link">
            Process
          </button>
          <button
            onClick={() => scrollToSection("tech-stack")}
            className="nav-link"
          >
            Tech Stack
          </button>
          <button onClick={() => scrollToSection("about")} className="nav-link">
            About
          </button>

          {/* Mobile-only actions (shown inside the slide-down menu) */}
          <div className="header-mobile-actions">
            <button
              onClick={() => scrollToSection("contact")}
              className="btn-primary nav-cta"
            >
              Contact
            </button>
          </div>
        </nav>

        <div className="header-actions">
          <button
            onClick={() => scrollToSection("contact")}
            className="btn-primary header-cta"
          >
            Contact
          </button>
          <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;